import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import '../styles/Contribute.css';

const Contribute = ({ lang = {} }) => {
  const [contributors, setContributors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/api/contributors')
      .then(r => r.json().then(d => ({ ok: r.ok, d })))
      .then(({ ok, d }) => {
        if (!ok) throw new Error(d.error || lang.CONTRIBUTE_LOAD_ERROR || 'Không tải được danh sách đóng góp.');
        setContributors(Array.isArray(d.contributors) ? d.contributors : []);
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, [lang.CONTRIBUTE_LOAD_ERROR]);

  // Group by category for a more readable layout
  const grouped = contributors.reduce((acc, c) => {
    const cat = c.category || lang.CONTRIBUTE_DEFAULT_CATEGORY || 'Khác';
    if (!acc[cat]) acc[cat] = [];
    acc[cat].push(c);
    return acc;
  }, {});
  const categoryOrder = Object.keys(grouped);

  return (
    <div className="contribute-page">
      <div className="terminal-section-header">
                <div className="terminal-section-titlebar">
                  root@ispclub:~/# cd /ispclub/contribute
                </div>
                <div className="terminal-section-body">
                  <span className="terminal-sh-line">&gt;_ sh contribute.sh</span>
                </div>
              </div>
      {loading && <p className="contribute-loading">{lang.CONTRIBUTE_LOADING || 'Đang tải danh sách...'}</p>}
      {error && <p className="contribute-error">{error}</p>}

      {!loading && !error && contributors.length === 0 && (
        <div className="contribute-empty">
          <p>{lang.CONTRIBUTE_EMPTY || 'Danh sách đóng góp đang được cập nhật.'}</p>
        </div>
      )}

      {!loading && contributors.length > 0 && categoryOrder.map((cat, ci) => (
        <section key={cat} className="contribute-section">
          <motion.h2
            className="contribute-category-title"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <span className="contribute-category-dot"></span>
            {cat}
          </motion.h2>
          <div className="contribute-grid">
            {grouped[cat].map((c, idx) => (
              <motion.article
                key={c.id}
                className={`contribute-card ${c.highlight ? 'is-highlight' : ''}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: idx * 0.05 }}
              >
                <div className="contribute-avatar-wrap">
                  {c.avatar ? (
                    <img
                      src={`/uploads/profiles/${c.avatar}`}
                      alt={c.name}
                      className="contribute-avatar"
                    />
                  ) : (
                    <div className="contribute-avatar contribute-avatar-fallback">
                      {c.name?.charAt(0)?.toUpperCase() || '?'}
                    </div>
                  )}
                  {c.highlight && <span className="contribute-highlight-ribbon">{lang.CONTRIBUTE_HIGHLIGHT || 'Nổi bật'}</span>}
                </div>
                <div className="contribute-card-body">
                  <h3 className="contribute-name">{c.name}</h3>
                  {c.title && <p className="contribute-role">{c.title}</p>}
                  {/* Gen of the member, pulled from their account record on
                      the server so it stays in sync if the admin updates
                      the member's gen later. */}
                  {c.gen && <p className="contribute-gen">Gen {c.gen}</p>}
                  {Array.isArray(c.contributions) && c.contributions.length > 0 && (
                    <ul className="contribute-list">
                      {c.contributions.map((line, i) => (
                        <li key={i}>{line}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </motion.article>
            ))}
          </div>
          {ci < categoryOrder.length - 1 && <div className="contribute-divider" />}
        </section>
      ))}

      <motion.section
        className="contribute-outro"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="contribute-outro-inner">
          <p className="contribute-outro-quote">
            {lang.CONTRIBUTE_OUTRO_QUOTE || '“ With sincere gratitude, we thank every single member of ISP Club — past, present, and future — whose collective spirit and dedication have shaped, and continue to shape, what ISP stands for today. ”'}
          </p>
          <p className="contribute-outro-sign">{lang.CONTRIBUTE_OUTRO_SIGN || '— ISP Club'}</p>
        </div>
      </motion.section>
    </div>
  );
};

export default Contribute;
